import _ from 'underscore';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useCouponContext } from '@bingads-webui-campaign-react/coupon-context';

import { PromotionalOfferView } from './promotional-offer-view';

export const PromotionalOfferContainer = ({
  getCouponCurrencyCode,
  showCouponCode,
  channelOfferText,
}) => {
  const {
    coupon, updateCoupon,
  } = useCouponContext();

  const handleCouponChanged = useCallback((id) => {
    updateCoupon({
      couponString: id,
      couponStringType: 'cco',
      isManual: true,
    });
  }, [updateCoupon]);

  return (
    <PromotionalOfferView
      resolvedCoupon={coupon}
      onCouponChanged={handleCouponChanged}
      getCouponCurrencyCode={getCouponCurrencyCode}
      showCouponCode={showCouponCode}
      channelOfferText={channelOfferText}
    />
  );
};

PromotionalOfferContainer.propTypes = {
  getCouponCurrencyCode: PropTypes.func,
  showCouponCode: PropTypes.bool,
  channelOfferText: PropTypes.string,
};

PromotionalOfferContainer.defaultProps = {
  getCouponCurrencyCode: _.noop,
  showCouponCode: false,
  channelOfferText: undefined,
};
